<template lang="pug">
  .abilityGroup
    p.abilityGroup__title 客戶資料
    .abilityGroup__item
      span.abilityGroup__subtitle 乘客頁面
      BaseAbilityRadioGroup(
        :value="abilityCustomer"
        :disabled="disabled"
        @handleRadioChange="setAbilityCustomer")
    .abilityGroup__item
      span.abilityGroup__subtitle 商家頁面
      BaseAbilityRadioGroup(
        :value="abilityStore"
        :disabled="disabled"
        @handleRadioChange="setAbilityStore")
    .abilityGroup__item
      span.abilityGroup__subtitle 自建地標
      BaseAbilityRadioGroup(
        :value="abilityLandmark"
        :disabled="disabled"
        @handleRadioChange="setAbilityLandmark")
</template>
<script>
import BaseAbilityRadioGroup from '@/components/common/select/BaseAbilityRadioGroup'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      abilityCustomer: 'positionStore/getCurrentAbilityCustomer',
      abilityStore: 'positionStore/getCurrentAbilityStore',
      abilityLandmark: 'positionStore/getCurrentAbilityLandmark',
    }),
  },
  methods: {
    ...mapActions({
      setAbilityCustomer: 'positionStore/setAbilityCustomer',
      setAbilityStore: 'positionStore/setAbilityStore',
      setAbilityLandmark: 'positionStore/setAbilityLandmark',
    }),
  },
  components: {
    BaseAbilityRadioGroup,
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_abilityGroup';
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityRadioGroup/AbilityGroupCustomerItems.vue